import React, { useMemo } from 'react';
import c from 'classnames';
import Immutable from 'immutable';
import { useTranslation } from 'react-i18next';

import { Taxonomy } from '@uncinc/react-drupal-core';

import type { MediaReferenceField } from '../../types/uncinc_profile/helpers/media';
import type { TaxonomyLocation } from '../../types/uncinc_profile/taxonomy';
import Button from '../Button';
import DynamicMediaItem from '../DynamicMediaItem';

import './style.scss';

interface ProjectHeroProps extends React.ComponentPropsWithoutRef<'div'> {
  logo?: MediaReferenceField<'image'>;
  title: string;
  status?: string;
  schoolTypes?: string[];
  location?: TaxonomyLocation;
  showLocationType?: boolean;
  url?: string;
}

const ProjectHero: React.FC<ProjectHeroProps> = (props) => {
  const { t } = useTranslation();

  const {
    className,
    logo,
    title,
    status,
    schoolTypes,
    location,
    showLocationType = true,
    url,
  } = props;

  const classNames = c('ProjectHero', className);
  const locationType = location?.field_type?.[0]?.entity?.name[0].value;

  const showStatus = useMemo(() => (
    (locationType && showLocationType) ||
    status ||
    (schoolTypes && schoolTypes.length > 0)
  ), [locationType, schoolTypes, showLocationType, status]);

  return (
    <div className={classNames}>
      {logo && (
        <div className="ProjectHero__logo">
          <DynamicMediaItem media={logo} imageAspectRatio="original" />
        </div>
      )}

      <div className="ProjectHero__info">
        <h1 className="ProjectHero__title mb-3">
          {title}
        </h1>

        {showStatus && (
          <p className="ProjectHero__status body--large mb-3">
            {(locationType && showLocationType) && (
              <span>
                {t('pages.node_project.school.location_type')}: {locationType}<br />
              </span>
            )}
            {status && (
              <>{t('pages.node_project.school.status')}: {status}<br /></>
            )}
            {schoolTypes && schoolTypes.length > 0 && (
              <>{t('pages.node_project.school.types')}: {schoolTypes.join(', ')}</>
            )}
          </p>
        )}

        <p className="ProjectHero__address">
          <Taxonomy
            entity={Immutable.fromJS(location)}
            viewMode="project"
          />
        </p>

        {url && (
          <Button href={url} type="primary" className="w-auto">
            {t('pages.node_project.to_website')}
          </Button>
        )}
      </div>
    </div>
  );
};


export default ProjectHero;
